export class NotificationEntity {
    constructor(
        public id: string,
        public message: string
    ) {}
}
